import React from 'react';
import './GoBackConfirmationModal.css';

export const GoBackConfirmationModal = ({isOpen, onClose, onConfirm}) =>
{
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content go-back-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Are you sure?</h2>
          <button
            className="modal-close"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          <p className="go-back-message">
            If you go back, you will lose all unsaved data.
          </p>
        </div>

        <div className="modal-footer">
          <button
            className="btn-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn-destructive"
            onClick={onConfirm}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};
